<script>
import configure from '../tools/configurator/configure'

export default {
  name: 'visibilitySingle',
  components: {
  },
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      theSwitch: false
    }
  },
  mounted: function () {
    this.theSwitch = this.option.visible
  },
  computed: {
    // theSwitch: {
    //   get: function () {
    //     let item = this.$store.getters['visibilitySingleList/getItemByName'](this.option.name)
    //     return item.visible
    //   },
    //   set: function (newValue) {
    //     this.$store.commit('visibilitySingleList/setVisibility', {optionName: this.option.name, switch: newValue})
    //   }
    // }
  },
  watch: {
    option: {
      deep: true,
      handler () {
        console.log('option has changed')
      }
    }
  },
  methods: {
    highlight () {
      // just adding the click event adds a highlight to a menu item
    },
    toggleSwitch () {
      var updatedCopy = Object.assign({}, this.option, {
        visible: this.theSwitch
      })
      this.$emit('clicked', updatedCopy)

      // console.log(this.theSwitch)
      // this.$store.commit('visibilitySingleList/setVisibility', {optionName: this.option.name, switch: this.theSwitch})
      configure.SetVisibilitySingle(this.theSwitch, this.option.objects, false)
    }
  }
}
</script>

<template>
<md-menu>
<md-list-item @click="highlight">
  <span class="md-list-item-text">{{option.title}}</span>
  <md-switch v-model="theSwitch" @change="toggleSwitch()"></md-switch>
</md-list-item>
</md-menu>
</template>

<style lang="scss" scoped>
  .md-menu {
    width: 300px;
    max-width: 100%;
    display: inline-block;
  }
</style>
